import styledComponents from 'styled-components';

import { IIconHelperProps, IShippyProIconProps } from './types';

const Styled = styledComponents.div`
  width: ${(props: IShippyProIconProps) => props.size}px;
  height: ${(props: IShippyProIconProps) => props.size}px;
  display: inline;
  line-height: ${(props: IShippyProIconProps) => props.size}px;
  text-align: center;
`;

export const LogoGray = ({ size, stroke, ...rest }: IShippyProIconProps) => {
  return (
    <Styled size={size} className={rest.className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className="svg"
        width={size}
        height={size}
        viewBox="0 0 18 10"
        {...rest}
      >
        <defs>
          <path
            id="huzjyr26fa"
            d="M1.292 1.292c1.722-1.723 4.515-1.723 6.238 0l.552.552.552-.552c1.722-1.722 4.514-1.722 6.237 0 1.134 1.11 1.585 2.744 1.18 4.279-.405 1.535-1.604 2.733-3.138 3.139-1.535.405-3.17-.045-4.28-1.18l-.551-.552-.552.552c-1.723 1.723-4.516 1.723-6.238 0-1.723-1.723-1.723-4.515 0-6.238zm3.12.524h-.018c-.04 0-.081 0-.122.003l.14-.003c-.067 0-.133.002-.198.007-.036.002-.072.006-.108.01l-.079.011c-.034.005-.068.01-.102.017l-.087.019c-.024.005-.049.01-.073.017-.039.01-.076.02-.113.032l-.05.016-.02.006c-.047.016-.093.033-.139.052l-.025.01-.003.001c-.054.023-.109.048-.162.074-.076.038-.15.08-.221.124l-.073.047c-.03.02-.059.04-.087.062l-.062.047-.046.037-.091.078-.052.048-.066.065-.056.06-.066.074c-.015.018-.03.035-.043.053l-.06.077-.05.068-.054.082-.03.048c-.022.035-.042.07-.062.106l-.028.054c-.047.089-.088.18-.123.275l-.017.047c-.012.031-.022.063-.032.096l-.024.08-.007.024-.02.08-.014.065.034-.145c-.023.089-.042.178-.056.267l-.007.05c-.015.106-.023.211-.025.316v.053c.001.224.031.445.089.659l.017.057c.16.55.502 1.042.986 1.386l.037.024c.054.038.11.074.17.108l.1.055c.067.034.135.065.204.094l-.161-.074.028.016.094.043.04.015.011.005c.038.017.076.031.114.045l.073.023c.11.037.222.064.335.085.01 0 .02.003.03.004.052.01.105.017.157.022l.031.003c.055.005.11.009.164.01h.024c.05.002.1.001.149 0 .014-.002.029-.002.043-.003.053-.002.107-.007.16-.013l.024-.003c.407-.05.802-.198 1.148-.437.13-.089.252-.19.365-.304l.55-.552-1.282-1.282 1.283-1.284-.55-.552-.084-.08.083.08c-.07-.071-.145-.138-.223-.2l-.084-.063c-.199-.146-.417-.262-.647-.344l-.017-.006c-.048-.018-.097-.033-.146-.047l-.05-.013c-.043-.012-.086-.023-.13-.032l-.066-.012c-.038-.008-.078-.014-.118-.02l-.087-.01-.095-.008c-.044-.003-.088-.005-.133-.006h-.04zm7.397 0c-.695-.015-1.382.25-1.893.76l-.55.552 1.282 1.284-1.282 1.282.55.552c.51.51 1.198.775 1.893.76l.19-.01c.252-.025.504-.086.746-.187.97-.402 1.603-1.348 1.603-2.398s-.633-1.997-1.603-2.398c-.242-.1-.494-.162-.747-.186z"
          />
        </defs>
        <g fill="none" fillRule="evenodd" strokeWidth={`${stroke}`}>
          <g transform="translate(-30 -428) translate(29 385) translate(1 35) translate(0 4) translate(.75 4.5)">
            <mask id="krfyf045lb" fill="#fff">
              <use xlinkHref="#huzjyr26fa" />
            </mask>
            <use fill="#46EBC8" fillRule="nonzero" xlinkHref="#huzjyr26fa" />
            <g fill="currentColor" mask="url(#krfyf045lb)">
              <path d="M0 0H16.5V16.5H0z" transform="translate(0 -4.125)" />
            </g>
          </g>
        </g>
      </svg>
    </Styled>
  );
};

export const Lightbulb = ({ size, stroke, ...rest }: IShippyProIconProps) => {
  return (
    <Styled size={size} className={rest.className}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 21 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...rest}
      >
        <defs>
          <path
            d="M11.7099622,1.5 C12.1577259,1.5 12.5272316,1.83506233 12.5814291,2.26813685 L12.5882724,2.37831021 L12.5882724,3.86633039 C12.5882724,4.08883025 12.5055378,4.2920064 12.3691544,4.44677293 C13.5486472,4.57263892 14.6984997,5.04077547 15.6620025,5.84999812 C17.8806689,7.71340232 18.4886265,10.8625018 17.1500213,13.4156304 L17.0229581,13.6460388 L16.9377632,13.7822243 L14.688,17.65 L14.6873147,18.6112344 L14.6922859,18.686057 L14.6912539,18.7755029 L14.689,18.7688999 L14.6891548,19.5440174 C14.6875454,21.1164467 13.4595202,22.4018347 11.9087705,22.4946418 L11.7351828,22.5 L11.6791848,22.5 C10.1056151,22.4983866 8.81973208,21.268645 8.72839024,19.7172149 L8.72320303,19.543556 L8.723,17.663 L6.41744083,13.6884618 L6.4303241,13.7042976 L6.38952336,13.6377287 C4.89340889,11.054537 5.46950104,7.76986912 7.75539982,5.84999812 C8.71969919,5.04010644 9.87065651,4.57186507 11.0507896,4.44527403 C10.9413934,4.32198682 10.866783,4.1675403 10.8413147,3.99700912 L10.831652,3.86633039 L10.831652,2.37831021 C10.831652,1.89323288 11.2248848,1.5 11.7099622,1.5 Z M5.54340002,16.6326571 C5.76235758,16.3976762 6.09211618,16.3009496 6.40331129,16.3804234 C6.7145064,16.4598972 6.95750512,16.7028959 7.03697889,17.014091 C7.10651844,17.2863867 7.04115462,17.5728951 6.87367505,17.7798746 L6.7957417,17.8634377 L5.74267622,18.9063648 C5.57883449,19.0744661 5.35436821,19.1697584 5.10945591,19.170809 C4.87874958,19.1672001 4.65855469,19.0737212 4.49384195,18.9083704 C4.18399353,18.5940184 4.15817283,18.1049922 4.41964363,17.758256 L4.49807923,17.6674576 L5.54340002,16.6326571 Z M16.6611428,16.6591313 C16.9407916,16.3768064 17.3704849,16.3204906 17.7099501,16.5084001 L17.8088425,16.5721179 L17.8642722,16.6199649 L18.9185162,17.6742273 C19.2565326,18.0171568 19.2565326,18.567963 18.9135118,18.9158983 C18.7540665,19.0731451 18.5409839,19.1641707 18.300292,19.1708646 C18.1046788,19.1699428 17.9161972,19.1036139 17.7665964,18.9868912 L17.6817556,18.9109304 L16.5850636,17.8076076 C16.321103,17.4591871 16.3535291,16.9696887 16.6611428,16.6591313 Z M8.88768003,7.19472237 C7.31175448,8.51728704 6.87245198,10.748072 7.79768664,12.5515268 L7.90205075,12.7430581 L7.95647794,12.8321286 L8.00614583,12.9246083 L8.018,12.955 L10.107,16.534 L10.831,16.534 L10.831,15.667 L10.0491503,14.88937 C9.8427436,14.6987282 9.74176709,14.4228213 9.77201653,14.1481468 L9.79309003,14.0307568 C9.87111177,13.7192629 10.1129055,13.4751774 10.4236494,13.3942205 C10.6955504,13.3233833 10.9823126,13.387323 11.1872266,13.5509071 L11.2697539,13.6270128 L11.715,14.062 L12.1918674,13.5900637 C12.5130555,13.3362256 12.9614663,13.3406073 13.2761541,13.5861172 L13.3662878,13.6669869 C13.6539994,13.9629979 13.6937638,14.4145148 13.4522297,14.7791794 L13.3793573,14.876298 L12.598,15.654 L12.598,16.534 L13.322,16.534 L15.4,12.963 L15.4102322,12.9364319 L15.4592611,12.8415619 L15.5115594,12.7536834 C16.5774013,10.9085722 16.1644529,8.56452149 14.5322443,7.19472237 C12.9000357,5.82492326 10.5198886,5.82492326 8.88768003,7.19472237 Z M21.0416141,10.8215637 C21.5266915,10.8215637 21.9199243,11.2147966 21.9199243,11.6998739 C21.9199243,12.1476376 21.584862,12.5171433 21.1517875,12.5713408 L21.0416141,12.5781841 L19.5535939,12.5781841 C19.0685166,12.5781841 18.6752837,12.1849512 18.6752837,11.6998739 C18.6752837,11.2521102 19.0103461,10.8826045 19.4434206,10.828407 L19.5535939,10.8215637 L21.0416141,10.8215637 Z M3.86633039,10.8215637 C4.35140773,10.8215637 4.74464061,11.2147966 4.74464061,11.6998739 C4.74464061,12.1476376 4.40957827,12.5171433 3.97650376,12.5713408 L3.86633039,12.5781841 L2.37831021,12.5781841 C1.89323288,12.5781841 1.5,12.1849512 1.5,11.6998739 C1.5,11.2521102 1.83506233,10.8826045 2.26813685,10.828407 L2.37831021,10.8215637 L3.86633039,10.8215637 Z M18.3102144,4.23067817 C18.5443407,4.23067817 18.7687195,4.32442218 18.9336486,4.49137737 C19.243497,4.80572937 19.2693177,5.29475564 19.0072009,5.64213008 L18.9285726,5.73311887 L17.8622149,6.78435033 C17.7071431,6.93763308 17.5009878,7.02834138 17.2580722,7.03972238 C16.903069,7.03941013 16.5831602,6.82542048 16.4473486,6.49742264 C16.3266271,6.20586899 16.3724678,5.87519947 16.5604927,5.62874971 L16.6376194,5.54051975 L17.6871705,4.49098183 C17.8517092,4.32442218 18.0760881,4.23067817 18.3102144,4.23067817 Z M5.11727617,4.23067817 C5.31238142,4.23067817 5.5007176,4.29577818 5.65205096,4.41261427 L5.73816878,4.48881735 L6.78999799,5.54064662 C7.04324545,5.79407585 7.11717855,6.17592199 6.97682471,6.50556036 C6.83647087,6.83519873 6.50996701,7.04654632 6.13671361,7.03911217 C5.96249192,7.03049554 5.79570824,6.9707189 5.6561635,6.86827256 L5.55692164,6.7835699 L4.49384195,5.72804256 C4.1558255,5.3851131 4.1558255,4.83430682 4.49423225,4.49098183 C4.65877103,4.32442218 4.88314986,4.23067817 5.11727617,4.23067817 Z"
            id="path-1"
          ></path>
        </defs>
        <g
          id="⚙️-Symbols"
          stroke="none"
          strokeWidth={`${stroke}`}
          fill="none"
          fillRule="evenodd"
        >
          <g id="34)-icon/light" transform="translate(-1.000000, -1.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
            <use
              id="Shape"
              fill="currentColor"
              fillRule="nonzero"
              xlinkHref="#path-1"
            ></use>
          </g>
        </g>
      </svg>
    </Styled>
  );
};

export const HandPointer = ({ size, stroke, ...rest }: IShippyProIconProps) => {
  return (
    <Styled size={size} className={rest.className}>
      <svg
        width={size}
        height={size}
        viewBox="-2.4 -1 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...rest}
      >
        <defs>
          <path
            id="cls-1"
            d="M9.644 7.758c.101-.046.206-.083.313-.111a3.026 3.026 0 012.21.248c.189.114.36.255.51.417.06.069.156.092.24.059a3.613 3.613 0 012.302.078c.44.176.806.502 1.03.92a.424.424 0 00.45.247 2.458 2.458 0 011.52.391 2.263 2.263 0 011.037 1.709c.013.217.013.435 0 .652v3.86a6.423 6.423 0 01-.359 2.133 5.36 5.36 0 01-1.304 2.015 5.217 5.217 0 01-2.837 1.5 7.85 7.85 0 01-1.232.124h-3.84a6.784 6.784 0 01-4.037-1.304 8.151 8.151 0 01-1.559-1.585c-1.18-1.487-2.354-2.98-3.554-4.447a2.217 2.217 0 01-.144-2.7c.321-.494.844-.821 1.429-.894a2.158 2.158 0 012.054.653.946.946 0 01.176.352.254.254 0 01-.144.306.28.28 0 01-.345 0 1.415 1.415 0 01-.235-.202 1.115 1.115 0 00-.652-.417 1.546 1.546 0 00-1.598.424 1.532 1.532 0 00-.215 1.786c.267.405.558.793.874 1.161 1.05 1.304 2.113 2.609 3.15 3.913a5.869 5.869 0 003.677 2.19c.34.064.685.094 1.03.092h4.207a4.715 4.715 0 003.339-1.448 4.82 4.82 0 001.46-3.508v-4.389c.031-.65-.339-1.252-.932-1.519a1.956 1.956 0 00-.652-.144 4.382 4.382 0 00-.718 0 .456.456 0 01-.508-.326c-.136-.36-.401-.658-.744-.834a1.76 1.76 0 00-.652-.196 2.921 2.921 0 00-1.565.163c-.228.111-.32.059-.508-.189a1.695 1.695 0 00-.946-.652 2.36 2.36 0 00-1.513.104c-.104.052-.189.137-.287.196a.424.424 0 01-.443.065c-.17-.085-.19-.254-.19-.424V2.404A1.715 1.715 0 007.845.78a1.676 1.676 0 00-1.748.326 1.832 1.832 0 00-.6 1.435v12.064c.003.099-.008.197-.032.293a.32.32 0 01-.613 0 .783.783 0 01-.033-.247V2.515c-.024-.658.21-1.3.652-1.787.38-.4.892-.65 1.442-.704a2.367 2.367 0 011.89.56c.472.399.764.97.81 1.585.011.217.011.435 0 .652v4.721l.032.216z"
          ></path>
          <path
            id="cls-2"
            d="M15.5 15.844v2.25a.828.828 0 01-.033.254.293.293 0 01-.287.222.28.28 0 01-.306-.183.704.704 0 01-.059-.287v-4.565a.73.73 0 01.059-.287.287.287 0 01.313-.176c.135.003.25.097.28.229.021.078.032.16.033.24v2.303zM12.741 15.837v2.244c.004.054.004.108 0 .163a.359.359 0 01-.339.332.346.346 0 01-.326-.345.79.79 0 010-.124v-4.565a.574.574 0 01.13-.372c.19-.189.483-.052.535.228.004.06.004.118 0 .177v2.262zM9.977 15.844v2.347c0 .248-.144.411-.34.405-.195-.007-.326-.163-.326-.405v-4.675c0-.248.144-.411.34-.404.195.006.326.156.326.404v2.328z"
          ></path>
        </defs>
        <g
          stroke="currentColor"
          strokeWidth={`${stroke}`}
          fill="none"
          fillRule="evenodd"
        >
          <g>
            <mask id="mask-hand-pointer" fill="white">
              <use xlinkHref="#cls-1"></use>
              <use xlinkHref="#cls-2"></use>
            </mask>
            <use
              id="Shape1"
              fill="currentColor"
              fillRule="nonzero"
              xlinkHref="#cls-1"
            ></use>
            <use
              id="Shape2"
              fill="currentColor"
              fillRule="nonzero"
              xlinkHref="#cls-2"
            ></use>
          </g>
        </g>
      </svg>
    </Styled>
  );
};

export const Print = ({ size, stroke, ...rest }: IShippyProIconProps) => {
  return (
    <Styled size={size} className={rest.className}>
      <svg
        width={size || 22}
        height={size || 22}
        viewBox="0 0 11 11"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...rest}
      >
        <title>Mask</title>
        <defs>
          <path
            d="M9.5,3.5 L9,3.5 L9,0.5 C9,0.2 8.8,0 8.5,0 L2.5,0 C2.2,0 2,0.2 2,0.5 L2,3.5 L1.5,3.5 C0.65,3.5 0,4.15 0,5 L0,7.5 C0,8.35 0.65,9 1.5,9 L2,9 L2,10.5 C2,10.8 2.2,11 2.5,11 L8.5,11 C8.8,11 9,10.8 9,10.5 L9,9 L9.5,9 C10.35,9 11,8.35 11,7.5 L11,5 C11,4.15 10.35,3.5 9.5,3.5 Z M3,1 L8,1 L8,3.5 L3,3.5 L3,1 Z M8,10 L3,10 L3,7 L8,7 L8,10 Z"
            id="path-print"
          ></path>
        </defs>
        <g
          id="👉-Shipped"
          stroke="none"
          strokeWidth={`${stroke}`}
          fill="none"
          fillRule="evenodd"
        >
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-print"></use>
          </mask>
          <use
            id="Mask"
            fill="var(--bs-green)"
            fillRule="nonzero"
            xlinkHref="#path-print"
          ></use>
        </g>
      </svg>
    </Styled>
  );
};

export const Calendar = ({ size, stroke = 1.5, ...rest }: IIconHelperProps) => {
  return (
    <Styled size={size} className={rest.className}>
      <svg
        width={size || 24}
        height={size || 24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M4 7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H18C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V7Z"
          stroke="currentColor"
          strokeWidth={`${stroke}`}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 3V7"
          stroke="currentColor"
          strokeWidth={`${stroke}`}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 3V7"
          stroke="currentColor"
          strokeWidth={`${stroke}`}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 11H20"
          stroke="currentColor"
          strokeWidth={`${stroke}`}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Styled>
  );
};

export const Duplicate = ({
  size,
  stroke = 1.5,
  ...rest
}: IIconHelperProps) => {
  return (
    <Styled size={size} className={rest.className}>
      <svg
        width={size || 24}
        height={size || 24}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 6.75C7.30109 6.75 7.11032 6.82902 6.96967 6.96967C6.82902 7.11032 6.75 7.30109 6.75 7.5V13.5C6.75 13.6989 6.82902 13.8897 6.96967 14.0303C7.11032 14.171 7.30109 14.25 7.5 14.25H13.5C13.6989 14.25 13.8897 14.171 14.0303 14.0303C14.171 13.8897 14.25 13.6989 14.25 13.5V7.5C14.25 7.30109 14.171 7.11032 14.0303 6.96967C13.8897 6.82902 13.6989 6.75 13.5 6.75H7.5ZM5.90901 5.90901C6.33097 5.48705 6.90326 5.25 7.5 5.25H13.5C14.0967 5.25 14.669 5.48705 15.091 5.90901C15.5129 6.33097 15.75 6.90326 15.75 7.5V13.5C15.75 14.0967 15.5129 14.669 15.091 15.091C14.669 15.5129 14.0967 15.75 13.5 15.75H7.5C6.90326 15.75 6.33097 15.5129 5.90901 15.091C5.48705 14.669 5.25 14.0967 5.25 13.5V7.5C5.25 6.90326 5.48705 6.33097 5.90901 5.90901Z"
          fill="currentColor"
          strokeWidth={`${stroke}`}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5 7.5C10.9142 7.5 11.25 7.83579 11.25 8.25V12.75C11.25 13.1642 10.9142 13.5 10.5 13.5C10.0858 13.5 9.75 13.1642 9.75 12.75V8.25C9.75 7.83579 10.0858 7.5 10.5 7.5Z"
          fill="currentColor"
          strokeWidth={`${stroke}`}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 10.5C7.5 10.0858 7.83579 9.75 8.25 9.75H12.75C13.1642 9.75 13.5 10.0858 13.5 10.5C13.5 10.9142 13.1642 11.25 12.75 11.25H8.25C7.83579 11.25 7.5 10.9142 7.5 10.5Z"
          fill="currentColor"
          strokeWidth={`${stroke}`}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 3.75C3.86193 3.75 3.75 3.86193 3.75 4V5.4C3.75 5.81421 3.41421 6.15 3 6.15C2.58579 6.15 2.25 5.81421 2.25 5.4V4C2.25 3.0335 3.0335 2.25 4 2.25H5.4C5.81421 2.25 6.15 2.58579 6.15 3C6.15 3.41421 5.81421 3.75 5.4 3.75H4ZM8.85 3C8.85 2.58579 9.18579 2.25 9.6 2.25H11C11.9665 2.25 12.75 3.0335 12.75 4V5.2C12.75 5.61421 12.4142 5.95 12 5.95C11.5858 5.95 11.25 5.61421 11.25 5.2V4C11.25 3.86193 11.1381 3.75 11 3.75H9.6C9.18579 3.75 8.85 3.41421 8.85 3ZM3 8.85C3.41421 8.85 3.75 9.18579 3.75 9.6V11C3.75 11.1381 3.86193 11.25 4 11.25H5.1C5.51421 11.25 5.85 11.5858 5.85 12C5.85 12.4142 5.51421 12.75 5.1 12.75H4C3.0335 12.75 2.25 11.9665 2.25 11V9.6C2.25 9.18579 2.58579 8.85 3 8.85Z"
          fill="currentColor"
          strokeWidth={`${stroke}`}
        />
      </svg>
    </Styled>
  );
};

export const SparklesFilled = ({
  size,
  stroke = 1.5,
  ...rest
}: IIconHelperProps) => {
  return (
    <Styled size={size} className={rest.className}>
      <svg
        width={size || 24}
        height={size || 24}
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M9.33333 11.401C9.64275 11.401 9.9395 11.524 10.1583 11.7428C10.3771 11.9615 10.5 12.2583 10.5 12.5677C10.5 12.2583 10.6229 11.9615 10.8417 11.7428C11.0605 11.524 11.3572 11.401 11.6667 11.401C11.3572 11.401 11.0605 11.2781 10.8417 11.0593C10.6229 10.8405 10.5 10.5438 10.5 10.2344C10.5 10.5438 10.3771 10.8405 10.1583 11.0593C9.9395 11.2781 9.64275 11.401 9.33333 11.401ZM9.33333 4.40104C9.64275 4.40104 9.9395 4.52396 10.1583 4.74275C10.3771 4.96154 10.5 5.25829 10.5 5.56771C10.5 5.25829 10.6229 4.96154 10.8417 4.74275C11.0605 4.52396 11.3572 4.40104 11.6667 4.40104C11.3572 4.40104 11.0605 4.27813 10.8417 4.05933C10.6229 3.84054 10.5 3.54379 10.5 3.23438C10.5 3.54379 10.3771 3.84054 10.1583 4.05933C9.9395 4.27813 9.64275 4.40104 9.33333 4.40104ZM5.25 11.401C5.25 10.4728 5.61875 9.58255 6.27513 8.92617C6.9315 8.26979 7.82174 7.90104 8.75 7.90104C7.82174 7.90104 6.9315 7.53229 6.27513 6.87592C5.61875 6.21954 5.25 5.3293 5.25 4.40104C5.25 5.3293 4.88125 6.21954 4.22487 6.87592C3.5685 7.53229 2.67826 7.90104 1.75 7.90104C2.67826 7.90104 3.5685 8.26979 4.22487 8.92617C4.88125 9.58255 5.25 10.4728 5.25 11.401Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={`${stroke}`}
        />
      </svg>
    </Styled>
  );
};
